import { cn } from '@/lib/utils';
import { getRiskColor } from './riskUtils';
import { useLocalization } from '@/hooks/useLocalization';

export const RiskGauge = ({ score, size = 'large' }: { score: number; size?: 'small' | 'large' }) => {
  const { t } = useLocalization();
  const radius = size === 'large' ? 80 : 40;
  const strokeWidth = size === 'large' ? 12 : 6;
  const circumference = Math.PI * radius;
  const progress = (score / 100) * circumference;

  const getGaugeColor = (s: number) => {
    if (s >= 70) return 'stroke-destructive';
    if (s >= 50) return 'stroke-amber-500';
    return 'stroke-emerald-500';
  };

  return (
    <div className="flex flex-col items-center">
      <svg width={radius * 2 + strokeWidth * 2} height={radius + strokeWidth * 2}>
        <path
          d={`M ${strokeWidth} ${radius + strokeWidth} A ${radius} ${radius} 0 0 1 ${radius * 2 + strokeWidth} ${radius + strokeWidth}`}
          fill="none"
          className="stroke-muted"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d={`M ${strokeWidth} ${radius + strokeWidth} A ${radius} ${radius} 0 0 1 ${radius * 2 + strokeWidth} ${radius + strokeWidth}`}
          fill="none"
          className={getGaugeColor(score)}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          style={{ transition: 'stroke-dashoffset 0.5s ease-out' }}
        />
      </svg>
      <div className={cn('text-center', size === 'large' ? '-mt-2' : '-mt-1')}>
        <span className={cn('font-bold', size === 'large' ? 'text-3xl' : 'text-lg', getRiskColor(score))}>
          {score}
        </span>
        {size === 'large' && <p className="text-xs text-muted-foreground mt-1">{t('Risk Score')}</p>}
      </div>
    </div>
  );
};

export default RiskGauge;
